import styled from "styled-components";
import { size } from "./Breakpoints";

/*
 * Separate rounded pills over the map, matching the RENT/BUY radios in the
 * search panel. The shadow moves from this wrapper to each label, or it would
 * outline the gaps between them.
 */
export const CheckboxWrap = styled.div`
    position: absolute;
    display: flex;
    gap: 0.5rem;
    margin: -2rem 0 0 0.5rem;

    @media screen and (max-width: ${size.sm}px) {
        align-items: center;
        justify-content: center;
        width: 100vw;
        margin: 0;
        padding: 0.5rem 0;
        background: #f3f3f3;
    }
`;

export const CheckboxLabel = styled.label`
    border-radius: 8px;
    box-shadow: -2px 3px 4px 1px #00000017;
    background: ${(props) => props.lettings && props.theme.darkblue};
    background: ${(props) => props.sales && props.theme.lightblue};
    background: ${(props) => props.filterResults && props.theme.green};

    color: ${(props) => (props.sales ? props.theme.darkblue : "white")};

    padding: 0.25rem 2rem 0.25rem 2rem;
    width: 6rem;
    display: inline-flex;
    font-size: 0.8rem;
    font-weight: 500;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    @media screen and (max-width: ${size.sm}px) {
        padding: 0.3rem 1rem 0.3rem 2rem;
        width: unset;
        font-size: 0.7rem;
    }
`;

export const CheckboxInput = styled.input`
    /* A round dot (25CF), like the RENT/BUY radios, not a square (25FE). */
    &:checked + ${CheckboxLabel}:before {
        content: "\x5c\x32\x35\x43\x46";
        position: absolute;
        margin: -0.42rem 0 0 -1.52rem;
        font-size: 1.2rem;
        color: transparent;
        text-shadow: 0 0 0 ${(props) => (props.filterResults ? props.theme.green : props.theme.darkblue)};
        z-index: 1;
        @media screen and (max-width: ${size.sm}px) {
            margin: -0.35rem 0 0 -1.45rem;
        }
    }
`;

/* Circular, matching RadioBox in RadioButton.js. */
export const CheckboxBox = styled.div`
    position: absolute;
    background: white;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    margin: -1px 0 0 -1.5rem;
    z-index: 0;
    @media screen and (max-width: ${size.sm}px) {
        margin: -1px 0 0 -1.45rem;
    }
`;
